import { onLCP } from 'web-vitals/attribution';
import type { LCPMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';

const onLargestContentfulPaint = (report: (m: MetricReport) => void): void => {
  onLCP((metric: LCPMetricWithAttribution) => {
    const a = metric.attribution;
    report({
      name: 'largest-contentful-paint',
      value: metric.value,
      unit: 'ms',
      rating: metric.rating,
      navigationType: metric.navigationType,
      id: metric.id,
      delta: metric.delta,
      attribution: {
        kind: 'lcp',
        target: a?.target,
        url: a?.url,
        timeToFirstByte: a?.timeToFirstByte,
        resourceLoadDelay: a?.resourceLoadDelay,
        resourceLoadDuration: a?.resourceLoadDuration,
        elementRenderDelay: a?.elementRenderDelay,
      },
    });
  });
};

export default onLargestContentfulPaint;
